import { render, staticRenderFns } from "./ActivitiesDialog.vue?vue&type=template&id=7bc2d77a&scoped=true&"
import script from "./ActivitiesDialog.vue?vue&type=script&lang=js&"
export * from "./ActivitiesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesDialog.vue?vue&type=style&index=0&id=7bc2d77a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc2d77a",
  null
  
)

export default component.exports